import { createSelector } from '@ngrx/store';
import {
  selectIsScheduledPayment,
  selectPaymentAuthorizationPending,
  selectPaymentStatusCheckCount,
  selectTransactionAuthorizationResultsList,
} from '../btpay/selectors';
import {
  selectSessionPaymentReference,
  selectTransactions,
  selectVirtualOtherwisePrimaryTenantId,
} from '../session-store';
import { getCurrentFormattedUtcDate } from '@arc/unified-payments-frontend/date-utils';
import {
  SerializableMap,
  TransactionAuthorizationResult,
  PaymentStatus,
} from '@arc/unified-payments-frontend/shared-payment';

export const selectPaymentStatusPollingIntervalData = createSelector(
  selectVirtualOtherwisePrimaryTenantId,
  selectSessionPaymentReference,
  selectPaymentAuthorizationPending,
  selectPaymentStatusCheckCount,
  selectTransactionAuthorizationResultsList,
  (
    tenantId,
    paymentReferenceNumber,
    paymentAuthorizationPending,
    statusCheckCount,
    transactionResults,
  ) => ({
    tenantId,
    paymentReferenceNumber,
    paymentAuthorizationPending,
    statusCheckCount,
    isScheduledTransaction: transactionResults.some(
      (x) => x.isScheduledTransaction,
    ),
  }),
);

export const selectPaymentStatusPollingCanceledTransactionResults =
  createSelector(
    selectTransactions,
    selectIsScheduledPayment,
    (transactions, isScheduledPayment) => {
      const results: SerializableMap<TransactionAuthorizationResult> = {};
      const paymentDate = getCurrentFormattedUtcDate();

      for (const transaction of transactions) {
        const result: TransactionAuthorizationResult = {
          gpalStatus: PaymentStatus.IN_PROGRESS,
          paymentDate,
          isScheduledTransaction: isScheduledPayment,
        };

        results[transaction.transactionReference] = result;
      }

      return results;
    },
  );
